import React from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Image } from '@daedalus/atlas/Image';
import { ImageProvider } from '@daedalus/core/src/staticContent/types/ImageProvider';
import { ProgressiveImageCarousel } from './ProgressiveImageCarousel';
const _exp = /*#__PURE__*/() => Flex.Column;
const CardGalleryContainer = /*#__PURE__*/styled(_exp())({
  name: "CardGalleryContainer",
  class: "ch8udof",
  propsAsIs: true
});
interface CardGalleryProps {
  /** Imaging service for resizing */
  imageProvider: ImageProvider;

  /** List of images to be displayed */
  images: string[];

  /** URL of image to be displayed when images error or less then 4 */
  placeHolderImage?: string;

  /** Whether the card is the priority card (card in the first position of the list) */
  isPriorityCard?: boolean;
}

/**
 * CardGallery is a selection of thumbnails and larger images for display on the hotel card
 *
 * This component requires a parent with a set height to work correctly as the main image is responsive
 * and is designed to grow with the height of the parent container.
 */
export const CardGallery: React.FC<CardGalleryProps> = ({
  images,
  imageProvider,
  isPriorityCard = false,
  placeHolderImage
}) => {
  const hasImage = images.length > 0;
  return <CardGalleryContainer data-id="HeroImage">
      {hasImage ? <ProgressiveImageCarousel images={images} imageProvider={imageProvider} isPriorityCard={isPriorityCard} placeHolderImage={placeHolderImage} /> : <Image url={placeHolderImage} />}
    </CardGalleryContainer>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");